<template>
  <div class="dashboard">
    <nav id="topnav" role="navigation" aria-label="main navigation" class="navbar is-dark">
        <div class="navbar-brand"><a href="/" class="navbar-item router-link-exact-active router-link-active"><span class="navbar-logo"> Mindsight.io</span></a><a role="button" class="navbar-burger"><span aria-hidden="true"></span><span aria-hidden="true"></span><span aria-hidden="true"></span></a></div>
        <div class="navbar-menu">
            <div class="navbar-end">
            </div>
        </div>
    </nav>
    <div class="deploy-placeholder-navbar">
    </div>
    <div class="section welcome-page">
        <div class="card welcome-card">
            <div class="card-content">
                <div class="content">
                    <b-field label="Organization" type="is-info">
                        <b-input v-model="nameOfOrg" placeholder="Enter Organization Name"></b-input>
                    </b-field>
                </div>
            </div>
            <footer class="card-footer">
                <a v-on:click="submitOrg" class="card-footer-item">Submit</a>
            </footer>
            </div>
    </div>
  </div>
</template>

<script>
// import { gql } from "apollo-boost";

export default {
  name: "Welcome",
  components: {},
  data() {
    return {
      nameOfOrg: ""
    };
  },
  methods: {
    submitOrg: function() {
      //console.log(this.nameOfOrg);
    }
  }
};
</script>


<style>
.welcome-card {
  margin: 0 auto;
  width: 320px;
}

.welcome-page {
  min-height: 95vh;
  height: auto;
}

.deploy-placeholder-navbar {
  height: 50px;
  background: white;
  width: 100%;
  border-bottom: 1px solid #dee2e6 !important;
}
</style>
